<template>
  <v-avatar
    :color="isBranded ? undefined : color"
    :style="isBranded ? brandIconAvatarStyle : {}"
    class="pt-2"
    :class="{ 'lighten-5': !isBranded }"
    :size="size ? Number(size) : 48"
    :rounded="rounded"
  >
    <h4
      class="text-capitalize font-weight-light"
      :class="{ 'white--text': !isBranded }"
      :style="isBranded ? brandIconColorStyle : {}"
    >
      {{ initials }}
    </h4>
  </v-avatar>
</template>

<script>
import {
  getBrandIconAvatarStyle,
  getBrandIconColorStyle,
  hasPartnerBrandColors,
} from "@/utils/brandColors";

export default {
  props: {
    label: {
      type: String,
    },
    brandable: {
      type: Boolean,
      default: false,
    },
    size: {},
    rounded: {
      type: String,
      default: null,
    },
  },
  name: "avatarComponent",
  computed: {
    business() {
      return this.$store.state.user.user_infor.current_business;
    },
    isBranded() {
      return this.brandable && hasPartnerBrandColors(this.business);
    },
    brandIconAvatarStyle() {
      return getBrandIconAvatarStyle(this.business);
    },
    brandIconColorStyle() {
      return getBrandIconColorStyle(this.business);
    },
    color() {
      let maxVal = 0xffffff;
      let randomNumber = Math.random() * maxVal;
      randomNumber = Math.floor(randomNumber);
      randomNumber = randomNumber.toString(16);
      let randColor = randomNumber.padStart(6, 0);
      return `#${randColor.toUpperCase()}`;
    },
    initials() {
      const arr = this.label.split(" ");

      const first = arr[0].split("")[0];

      let second = "";

      if (arr.length > 1) {
        second = arr[1].replace(" ", "").split("")[0];
      }

      if (second) {
        return (first + second).toUpperCase();
      }
      return first.toUpperCase();
    },
  },
};
</script>

<style scoped></style>
